import Algorithms from "./Algorithms";

export default Algorithms;